import { z } from 'zod';

import { AuthorizationType } from '@/components/modules/Webhooks/schemas/AuthorizationType';
import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { discriminatedUnionError, jsonValidation, requiredString, requiredUrl } from '@/utils/zodUtils';

const WebhookCommonSchema = (t: GetTextIdTranslationType) =>
  z.object({
    target: requiredUrl(t),
    authorizationType: z.nativeEnum(AuthorizationType),
    additionalPayload: z
      .string()
      .refine((value) => !(value && !jsonValidation(value)), { message: t('INVALID_JSON') })
      .optional(),
  });

export const AddOrEditWebhookFormSchema = (t: GetTextIdTranslationType) =>
  z.discriminatedUnion(
    'authorizationType',
    [
      WebhookCommonSchema(t).extend({
        authorizationType: z.literal(AuthorizationType.NO_AUTH),
      }),
      WebhookCommonSchema(t).extend({
        authorizationType: z.literal(AuthorizationType.BASIC),
        authorizationHeader: requiredString(t),
      }),
      WebhookCommonSchema(t).extend({
        authorizationType: z.literal(AuthorizationType.OAUTH_2),
        authorization: z.object({
          url: requiredUrl(t),
          clientId: requiredString(t),
          clientSecret: requiredString(t),
          username: requiredString(t),
          password: requiredString(t),
        }),
      }),
    ],
    discriminatedUnionError(t),
  );

export type AddOrEditWebhookFormType = z.infer<ReturnType<typeof AddOrEditWebhookFormSchema>>;
